import _extends from "@babel/runtime/helpers/extends";
import React from "react";
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    config = props.config,
    valueFormat = props.valueFormat,
    use12Hours = props.use12Hours,
    readonly = props.readonly,
    customProps = props.customProps;
  var onChange = function onChange(e) {
    var value = e.target.value;
    if (value == "") value = undefined;
    setValue(value);
  };
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "time",
    value: value || "",
    disabled: readonly,
    onChange: onChange
  }, customProps));
});